module.exports = __webpack_public_path__ + "static/media/11NEPAD3.440c8ec6.jpg";